<template>
  <perfect-scrollbar>
    <div class="wrapper">
      <div class="sidebar-menu" id="menu-lateral">
        <ul class="menu-indecx">
          <router-link :to="`/dashboard/${userAuth.companyId}`">
            <li
              v-if="userProfile.permissions.dashboard.menu"
              :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            >
              <span class="icon">
                <font-awesome-icon :icon="['fas', 'home']" />
              </span>
              <span class="label-menu-indecx">
                {{ $t('menu.sidebar.dashboard') }}
              </span>
            </li>
          </router-link>
          <router-link :to="`/panels`">
            <li
              v-if="company.panels && userProfile.permissions.panels.view_menu"
              :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            >
              <span class="icon">
                <font-awesome-icon :icon="['fas', 'table']" />
              </span>
              <span class="label-menu-indecx">
                {{ $t('panel.titleSideBar') }}
              </span>
            </li>
          </router-link>
          <!-- <router-link :to="`/call-center`">
          <li
            v-if="company.channelCallCenter"
            :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
          >
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'phone-alt']" />
            </span>
            <span class="label-menu-indecx">
              Call-center
            </span>
          </li>
        </router-link> -->

          <li
            v-if="userProfile.permissions.actions.menu_list"
            v-b-toggle.submenu-actions
            :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            @click="closeOpenedSubmenus('actions')"
          >
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'bolt']" />
            </span>
            <span class="label-menu-indecx">
              {{ $t('menu.sidebar.actions') }}
            </span>
          </li>
          <b-collapse id="submenu-actions" v-model="actionsVisible">
            <ul class="submenu">
              <router-link
                to="/action-list"
                v-if="userProfile.permissions.actions.menu_list"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'th-list']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.actionList') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/new-action"
                v-if="userProfile.permissions.actions.create"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'plus']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.newAction') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/action-group"
                v-if="userProfile.permissions.action_groups.menu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <i class="fas fa-layer-group"></i>
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.actionGroup') }}
                  </span>
                </li>
              </router-link>
            </ul>
          </b-collapse>
          <li
            v-if="userProfile.permissions.answers.menu"
            v-b-toggle.submenu-answers
            :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            @click="closeOpenedSubmenus('answers')"
          >
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'search']" />
            </span>
            <span class="label-menu-indecx">
              {{ $t('menu.sidebar.answers') }}
            </span>
          </li>
          <b-collapse id="submenu-answers" v-model="answersVisible">
            <ul class="submenu">
              <router-link
                to="/answers"
                v-if="userProfile.permissions.answers.menu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'th-list']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.answersList') }}
                  </span>
                </li>
              </router-link>
              <router-link to="/manual">
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                  v-if="userProfile.permissions.manual.menu"
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'edit']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.manualAnswer') }}
                  </span>
                </li>
              </router-link>
              <router-link
                v-if="company.enableSentimentAnalyze"
                to="/sentiment"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'hand-holding-heart']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.sentiment') }}
                  </span>
                </li>
              </router-link>
              <router-link to="/categorization">
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                  v-if="userProfile.permissions.answers.categorization"
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'th-large']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.categorization') }}
                  </span>
                </li>
              </router-link>
              <router-link to="/categorization-additional">
                <li
                  v-if="userAuth.companyId === '618930fd630b4d6b6d2b3b32' ||
                        userAuth.companyId === '608847fadef1b07e809ad539' ||
                        userAuth.companyId === '63b7101381f28d001a2748bb' ||
                        userAuth.companyId === '63b70ed581f28d001a272dac'"
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'th-large']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.categorizationAdditional') }}
                  </span>
                </li>
              </router-link>
            </ul>
          </b-collapse>
          <li
            v-if="userProfile.permissions.submits.menu"
            v-b-toggle.submenu-submits
            :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            @click="closeOpenedSubmenus('submits')"
          >
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'paper-plane']" />
            </span>
            <span class="label-menu-indecx">
              {{ $t('menu.sidebar.invites') }}
            </span>
          </li>
          <b-collapse id="submenu-submits" v-model="submitsVisible">
            <ul class="submenu">
              <router-link
                to="/resend"
                v-if="userProfile.permissions.submits.resendMenu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'redo-alt']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.resend') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/reminders"
                v-if="userProfile.permissions.submits.reminderMenu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <i class="fas fa-bell"></i>
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.reminders') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/scheduling"
                v-if="userProfile.permissions.submits.schedulingMenu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <i class="fas fa-clock"></i>
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.scheduling') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/resendwpp"
                v-if="userProfile.permissions.submits.resendWppMenu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <i class="fab fa-whatsapp"></i>
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.resendwpp') }}
                  </span>
                </li>
              </router-link>
            </ul>
          </b-collapse>
          <!--<router-link
          to="/treatments"
          v-if="userProfile.permissions.treatments.menu"
        >
          <li
            :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
          >
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'sync-alt']" />
            </span>
            <span class="label-menu-indecx">
              {{ $t('menu.sidebar.treatments') }}
            </span>
          </li>
        </router-link>-->
          <li
            v-if="userProfile.permissions.treatments.menu"
            v-b-toggle.submenu-treatments
            :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            @click="closeOpenedSubmenus('treatments')"
          >
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'infinity']" />
            </span>
            <span class="label-menu-indecx">
              {{ $t('menu.sidebar.treatments') }}
            </span>
          </li>
          <!-- old treatments -->
          <b-collapse
            id="submenu-treatments"
            v-model="treatmentsVisible"
            v-if="
              userAuth.companyId !== '5d8ba15696fa442270173557' &&
              userAuth.companyId !== '5edfb0342e03a449708e67df' &&
              userAuth.companyId !== '623b4f72794c886f75a70d2c' &&
              userAuth.companyId !== '65e768874f072a002fb1a8b7'
            "
          >
            <ul class="submenu">
              <router-link
                to="/treatments"
                v-if="userProfile.permissions.treatments.menu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'reply']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.individual') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/close-the-loop"
                v-if="userProfile.permissions.treatments.bulk"
              >
                <li
                  v-if="
                    userAuth.companyId !== '5e18ccd0dc36a60022491bdf' &&
                    userAuth.companyId !== '61965aa04be7ea63c8f83435' &&
                    userAuth.companyId !== '5eea25739b8df13f10e8da40' &&
                    userAuth.companyId !== '60251d0f3a8fc31cf03887f2'
                  "
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'reply-all']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.bulk') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/treatments-revision"
                v-if="company.enableTreatmentRevision && userProfile.permissions.treatments.revision"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <i class="fas fa-file-alt"></i>
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.treatmentsReview') }}
                  </span>
                </li>
              </router-link>
            </ul>
          </b-collapse>
          <!-- old treatments -->
          <!-- new treatments -->
          <b-collapse
            id="submenu-treatments"
            v-model="treatmentsVisible"
            v-if="
              userAuth.companyId === '5d8ba15696fa442270173557' ||
              userAuth.companyId === '5edfb0342e03a449708e67df' ||
              userAuth.companyId === '623b4f72794c886f75a70d2c' ||
              userAuth.companyId === '65e768874f072a002fb1a8b7'
            "
          >
            <ul class="submenu">
              <router-link
                to="/close-the-loop"
                v-if="userProfile.permissions.treatments.bulk"
              >
                <li
                  v-if="
                    userAuth.companyId !== '5e18ccd0dc36a60022491bdf' &&
                    userAuth.companyId !== '61965aa04be7ea63c8f83435' &&
                    userAuth.companyId !== '5eea25739b8df13f10e8da40' &&
                    userAuth.companyId !== '60251d0f3a8fc31cf03887f2' &&
                    userAuth.companyId !== '65e768874f072a002fb1a8b7'
                  "
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'reply-all']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.bulk') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/treatments"
                v-if="userProfile.permissions.treatments.menu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'reply']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.individual') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/separated-treatments"
                v-if="
                  userProfile.permissions.treatments.menu &&
                  userProfile.permissions.treatments.closetheloop
                "
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fa', 'user']" />
                  </span>
                  <span class="label-menu-indecx"> Close the loop </span>
                </li>
              </router-link>
              <router-link
                to="/treatments-revision"
                v-if="company.enableTreatmentRevision && userProfile.permissions.treatments.revision"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <i class="fas fa-file-alt"></i>
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.treatmentsReview') }}
                  </span>
                </li>
              </router-link>
            </ul>
          </b-collapse>
          <!-- new treatments -->
          <li
            v-if="userProfile.permissions.reports.menu"
            v-b-toggle.submenu-reports
            :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            @click="closeOpenedSubmenus('reports')"
          >
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'chart-bar']" />
            </span>
            <span class="label-menu-indecx">
              {{ $t('menu.sidebar.reports') }}
            </span>
          </li>
          <b-collapse id="submenu-reports" v-model="reportsVisible">
            <ul class="submenu">
              <router-link
                to="/reports"
                v-if="userProfile.permissions.reports.menu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'list']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.reportsList') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/powerbi"
                v-if="
                  company.enablePowerBI &&
                  userProfile.permissions.reports.powerbi
                "
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'chart-line']" />
                  </span>
                  <span class="label-menu-indecx"> PowerBI </span>
                </li>
              </router-link>
              <!-- <router-link
                to="/aianalysis"
                v-if="
                  company.enableAIAnalysis &&
                  userProfile.permissions.reports.AIAnalysis
                "
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'robot']" />
                    <svg
                      width="18"
                      height="19"
                      viewBox="0 0 18 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1796_21340)">
                        <path
                          class="svg-icon-path"
                          d="M10.125 2.77744C10.125 3.11875 9.98017 3.42541 9.75 3.63643V5.08232H13.5C14.7427 5.08232 15.75 6.11425 15.75 7.38719V15.0701C15.75 16.3431 14.7427 17.375 13.5 17.375H4.5C3.25736 17.375 2.25 16.3431 2.25 15.0701V7.38719C2.25 6.11425 3.25736 5.08232 4.5 5.08232H8.25V3.63643C8.01983 3.42541 7.875 3.11875 7.875 2.77744C7.875 2.14096 8.3787 1.625 9 1.625C9.6213 1.625 10.125 2.14096 10.125 2.77744ZM4.5 6.6189C4.08579 6.6189 3.75 6.96288 3.75 7.38719V15.0701C3.75 15.4944 4.08579 15.8384 4.5 15.8384H13.5C13.9142 15.8384 14.25 15.4944 14.25 15.0701V7.38719C14.25 6.96288 13.9142 6.6189 13.5 6.6189H9.75H8.25H4.5ZM1.5 8.92378H0V13.5335H1.5V8.92378ZM16.5 8.92378H18V13.5335H16.5V8.92378ZM6.75 12.3811C7.37132 12.3811 7.875 11.8651 7.875 11.2287C7.875 10.5922 7.37132 10.0762 6.75 10.0762C6.12868 10.0762 5.625 10.5922 5.625 11.2287C5.625 11.8651 6.12868 12.3811 6.75 12.3811ZM11.25 12.3811C11.8713 12.3811 12.375 11.8651 12.375 11.2287C12.375 10.5922 11.8713 10.0762 11.25 10.0762C10.6287 10.0762 10.125 10.5922 10.125 11.2287C10.125 11.8651 10.6287 12.3811 11.25 12.3811Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1796_21340">
                          <rect
                            width="18"
                            height="18"
                            fill="white"
                            transform="translate(0 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.aiAnalysis') }}
                  </span>
                </li>
              </router-link> -->
            </ul>
          </b-collapse>
          <li
            v-if="userProfile.permissions.clients.menu"
            v-b-toggle.submenu-clients
            :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            @click="closeOpenedSubmenus('clients')"
          >
            <span class="icon">
              <font-awesome-icon :icon="['fas', 'address-book']" />
            </span>
            <span class="label-menu-indecx">
              {{ $t('menu.sidebar.clients') }}
            </span>
          </li>
          <b-collapse id="submenu-clients" v-model="clientsVisible">
            <ul class="submenu">
              <router-link
                to="/clients"
                v-if="userProfile.permissions.clients.menu"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'users']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.clientsList') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/quarentines"
                v-if="
                  userProfile.type === 'admin' || userProfile.type === 'master'
                "
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <font-awesome-icon :icon="['fas', 'clock']" />
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.quarentine') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/blocklist"
                v-if="
                  userProfile.type === 'admin' || userProfile.type === 'master'
                "
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <i class="fas fa-clipboard-list"></i>
                  </span>
                  <span class="label-menu-indecx"> Blocklist </span>
                </li>
              </router-link>
            </ul>
          </b-collapse>
          <li
            v-b-toggle.submenu-files
            :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            @click="closeOpenedSubmenus('files')"
          >
            <span class="icon">
              <i class="fa fa-archive" aria-hidden="true"></i>
            </span>
            <span class="label-menu-indecx">
              {{ $t('menu.sidebar.files') }}
            </span>
          </li>
          <b-collapse id="submenu-files" v-model="filesVisible">
            <ul class="submenu">
              <router-link
                v-if="userProfile.permissions.files.download"
                to="/downloads"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <i class="fa fa-download" aria-hidden="true"></i>
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.downloads') }}
                  </span>
                </li>
              </router-link>
              <router-link
                to="/uploads"
                v-if="userProfile.permissions.files.upload"
              >
                <li
                  :class="
                    shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'
                  "
                >
                  <span class="icon">
                    <i class="fa fa-upload" aria-hidden="true"></i>
                  </span>
                  <span class="label-menu-indecx">
                    {{ $t('menu.sidebar.uploads') }}
                  </span>
                </li>
              </router-link>
            </ul>
          </b-collapse>
          <router-link to="/trash" v-if="userProfile.permissions.trash.menu">
            <li
              :class="shortMenu ? 'small-menu-indecx-item' : 'menu-indecx-item'"
            >
              <span class="icon">
                <i class="fas fa-trash-alt"></i>
              </span>
              <span class="label-menu-indecx">
                {{ $t('menu.sidebar.reccycleBin') }}
              </span>
            </li>
          </router-link>
        </ul>
        <div class="version">
          <span class="label-menu-indecx">
            {{ $t('menu.sidebar.version') }}: 2.9.31
          </span>
        </div>
      </div>
    </div>
  </perfect-scrollbar>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
// import EventBus from '../../../eventBus';
import Vue from 'vue';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

Vue.use(PerfectScrollbar);

export default {
  name: 'Sidebar',

  data: () => ({
    userAuth: {
      companyId: null,
    },
    actionsVisible: false,
    answersVisible: false,
    submitsVisible: false,
    treatmentsVisible: false,
    filesVisible: false,
    clientsVisible: false,
    reportsVisible: false,
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('settings', ['shortMenu']),
    ...mapFields('companies', ['company']),
  },
  // mounted() {
  //   EventBus.$on('drawer', (resp) => {
  //     window.console.log(resp);
  //     this.shortMenu = resp;
  //   });
  // },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.$store.state.settings.shortMenu = true;

    await this.getCompany({
      id: this.userAuth.companyId,
      token: this.userAuth.token,
    });
    // if (!this.userProfile.permissions.actions.menu_list) {
    //   this.$router.push('/dashboard');
    // }
  },
  methods: {
    ...mapActions('companies', ['getCompany']),
    closeOpenedSubmenus(submenu) {
      switch (submenu) {
        case 'actions':
          this.answersVisible = false;
          this.submitsVisible = false;
          this.treatmentsVisible = false;
          this.filesVisible = false;
          this.clientsVisible = false;
          this.reportsVisible = false;
          // this.actionsVisible = !this.actionsVisible;
          break;
        case 'answers':
          this.actionsVisible = false;
          this.submitsVisible = false;
          this.treatmentsVisible = false;
          this.filesVisible = false;
          this.clientsVisible = false;
          this.reportsVisible = false;
          // this.answersVisible = !this.answersVisible;
          break;
        case 'submits':
          this.actionsVisible = false;
          this.answersVisible = false;
          this.treatmentsVisible = false;
          this.filesVisible = false;
          this.clientsVisible = false;
          this.reportsVisible = false;
          // this.submitsVisible = !this.submitsVisible;
          break;
        case 'treatments':
          this.actionsVisible = false;
          this.answersVisible = false;
          this.submitsVisible = false;
          this.filesVisible = false;
          this.clientsVisible = false;
          this.reportsVisible = false;
          // this.treatmentsVisible = !this.treatmentsVisible;
          break;
        case 'files':
          this.actionsVisible = false;
          this.answersVisible = false;
          this.submitsVisible = false;
          this.treatmentsVisible = false;
          this.reportsVisible = false;
          this.clientsVisible = false;
          // this.filesVisible = !this.filesVisible;
          break;
        case 'clients':
          this.actionsVisible = false;
          this.answersVisible = false;
          this.submitsVisible = false;
          this.treatmentsVisible = false;
          this.reportsVisible = false;
          this.filesVisible = false;
          // this.clientsVisible = !this.clientsVisible;
          break;
        case 'reports':
          this.actionsVisible = false;
          this.answersVisible = false;
          this.submitsVisible = false;
          this.treatmentsVisible = false;
          this.filesVisible = false;
          this.clientsVisible = false;
          // this.reportsVisible = !this.reportsVisible;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style>
.content .sidebar {
 background: #212121;
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/mixins.scss';
@import '@/themes/default/placeholders.scss';

.wrapper .sidebar-menu .menu-indecx {
  background: #212121;
}

.content .sidebar {
 background: #212121;
}

.wrapper {
  .sidebar-menu {
    transition: all 0.2s linear;
    width: 95px;
    height: calc(100vh - 67px);
    min-height: 100%;
    display: flex;
    flex-direction: column;
    background: #212121;

    // @media screen and (max-width: 575px) {
    //   height: calc(100vh - 58.4px);
    // }

    @include bg-color($secondary);
    .menu-indecx {
      @extend %normalize-list, %half-padding-top;
      display: flex;
      flex-direction: column;
      .menu-indecx-item {
        color: $gray;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 60px;
        border-bottom: 1px solid $gray-light-white;
        cursor: pointer;
        font-size: 1.05em;
        .icon {
          width: 60px;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .label-menu-indecx {
          font-size: 0.9em;
          display: flex;
        }

        &:hover {
          @include bg-color($primary);
          color: $white;
        }
      }

      .submenu {
        padding-left: 0;
        list-style: none;
        background-color: #000;
        .menu-indecx-item {
          color: $gray;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 60px;
          border-bottom: 1px solid $gray-light-white;
          cursor: pointer;
          font-size: 1.1em;
          .icon {
            width: 60px;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .label-menu-indecx {
            font-size: 0.9em;
            display: flex;
          }

          &:hover {
            @include bg-color($primary);
            color: $white;
          }
        }
      }

      .small-menu-indecx-item {
        padding-top: 5px;
        color: $gray;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 60px;
        border-bottom: 1px solid $gray-light-white;
        cursor: pointer;
        font-size: 1.1em;
        .icon {
          width: 60px;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .label-menu-indecx {
          font-size: 0.63em;
          display: flex;
          text-align: center;
          padding-bottom: 5px;
        }

        &:hover {
          @include bg-color($primary);
          color: $white;
        }
      }
    }

    .version {
      height: 100%;
      color: $gray;
      display: flex;
      align-items: flex-end;
      font-size: 0.63em;
      margin-bottom: 10px;
      justify-content: center;
      background: #212121;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/sidebar/index.vue